// extracted by mini-css-extract-plugin
export default {"Container":"BottomNav_Container__64ffX"};